import { apolloClient } from "../../apollo/graphql";
import {
  GET_WALL_OFFICE_USERS,
  WALL_SEARCH_COMPANIES,
  WALL_SEARCH_EMPLOYEES,
} from "../../apollo/queries/wall";
import { Employee } from "../process/types/processTypes";
import { Company } from "../setups/types/setupTypes";
import { WallUser } from "./types/wallTypes";

export async function searchEmployees(searchText: string): Promise<Employee[]> {
  const res = await apolloClient.query({
    query: WALL_SEARCH_EMPLOYEES,
    variables: { searchText },
    fetchPolicy: "network-only",
  });
  return (res.data?.wallSearchEmployees ?? []) as Employee[];
}

export async function searchCompanies(searchText: string): Promise<Company[]> {
  const res = await apolloClient.query({
    query: WALL_SEARCH_COMPANIES,
    variables: { searchText },
    fetchPolicy: "network-only",
  });
  return (res.data?.wallSearchCompanies ?? []) as Company[];
}

export async function fetchOfficeUsers(): Promise<WallUser[]> {
  const res = await apolloClient.query({
    query: GET_WALL_OFFICE_USERS,
    fetchPolicy: "network-only",
  });
  return (res.data?.wallOfficeUsers ?? []) as WallUser[];
}

export const employeeLabel = (e: Employee): string =>
  `${e.givenName ?? ""} ${e.surName ?? ""}`.trim() +
  (e.referenceNumber ? ` (#${e.referenceNumber})` : "");
